export const CACHE_KEY_LABS = "Labs";
export const CACHE_KEY_LABS_PICKLIST = "labs_picklist";
export const ENABLE_LABS_AZURE_API_FEATURE_FLAG = "sqb.enable-labs-azure-api";
